import { render, staticRenderFns } from "./DelaisEdit.vue?vue&type=template&id=f349f6c2&"
import script from "./DelaisEdit.vue?vue&type=script&lang=js&"
export * from "./DelaisEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports